import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ShopperProvider } from "@/components/customer/ShopperProvider";
import { LangProvider } from "@/lib/i18n";
import ExtranetLogin from "@/pages/extranet/ExtranetLogin";
import SettingsPage from "@/pages/extranet/SettingsPage";
import Home from "@/pages/customer/Home";
import SearchResults from "@/pages/customer/SearchResults";
import HotelDetail from "@/pages/customer/HotelDetail";
import Checkout from "@/pages/customer/Checkout";
import BookingPage from "@/pages/customer/BookingPage";
import FindBooking from "@/pages/customer/FindBooking";
import PropertySite from "@/pages/customer/PropertySite";
import ExtranetLayout from "@/components/extranet/ExtranetLayout";
import Dashboard from "@/pages/extranet/Dashboard";
import Reservations from "@/pages/extranet/Reservations";
import RatesCalendar from "@/pages/extranet/RatesCalendar";
import PropertySettings from "@/pages/extranet/PropertySettings";
import ChannelManager from "@/pages/extranet/ChannelManager";
import RoomsRatePlans from "@/pages/extranet/RoomsRatePlans";
import Promotions from "@/pages/extranet/Promotions";
import Reviews from "@/pages/extranet/Reviews";
import CommissionReport from "@/pages/extranet/CommissionReport";
import CommissionInvoice from "@/pages/extranet/CommissionInvoice";
import PromoPage from "@/pages/customer/PromoPage";
import ReviewPage from "@/pages/customer/ReviewPage";

function App() {
  return (
    <ShopperProvider>
    <LangProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/hotel/:id" element={<HotelDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/booking/:code" element={<BookingPage />} />
        <Route path="/find-booking" element={<FindBooking />} />
        <Route path="/p/:slug" element={<PropertySite />} />
        <Route path="/review/:token" element={<ReviewPage />} />
        <Route path="/promo/:id" element={<PromoPage />} />
        <Route path="/extranet/login" element={<ExtranetLogin />} />
        <Route path="/extranet/invoice/:pid/:month" element={<CommissionInvoice />} />
        <Route path="/extranet" element={<ExtranetLayout />}>
          <Route path="settings" element={<SettingsPage />} />
          <Route index element={<Dashboard />} />
          <Route path="reservations" element={<Reservations />} />
          <Route path="rates" element={<RatesCalendar />} />
          <Route path="rooms" element={<RoomsRatePlans />} />
          <Route path="promotions" element={<Promotions />} />
          <Route path="property" element={<PropertySettings />} />
          <Route path="channel" element={<ChannelManager />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="commission" element={<CommissionReport />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
    </LangProvider>
    </ShopperProvider>
  );
}

export default App;
